export default __webpack_public_path__ + "static/media/Highlord's War Maul.5d6f6b8e.jpg";